/**
 * Logger utility for development debugging
 * Only logs in development mode
 */
class Logger {
  private isDev = import.meta.env.DEV;

  debug(...args: unknown[]): void {
    if (this.isDev) {
      console.log('[DEBUG]', ...args);
    }
  }

  info(...args: unknown[]): void {
    if (this.isDev) {
      console.info('[INFO]', ...args);
    }
  }

  warn(...args: unknown[]): void {
    if (this.isDev) {
      console.warn('[WARN]', ...args);
    }
  }

  error(...args: unknown[]): void {
    // Always log errors, even in production
    console.error('[ERROR]', ...args);
  }

  group(label: string): void {
    if (this.isDev) {
      console.group(label);
    }
  }

  groupEnd(): void {
    if (this.isDev) {
      console.groupEnd();
    }
  }
}

export const logger = new Logger();
